import React from 'react';
import _get from 'lodash/get';

export default function Content({ data }) {
  const name = _get(data, 'name', 'the');
  const isActive = _get(data, 'is_active', false);
  const isEnabling = !isActive;

  return (
    <>
      <p>
        You are about to {isEnabling ? 'enable' : 'disable'},{' '}
        <strong>{name}</strong> return window exception.
      </p>
      <p className="text-muted mb-0">Are you sure?</p>
    </>
  );
}
